import { CanvasSkeleton } from "@/components/skeletons";
import { FreeFormCanvasLiveMobileView } from "@/components/slides/editor/canvas/FreeFormCanvasLiveMobileView";
import { GrammarFormLiveMobileView } from "@/components/slides/editor/canvas/grammar/form/GrammarFormLiveMobileView";
import { GrammarResponseLiveMobileView } from "@/components/slides/editor/canvas/grammar/response/GrammarResponseLiveMobileView";
import { GrammarSentenceLiveMobileView } from "@/components/slides/editor/canvas/grammar/sentence/GrammarSentenceLiveMobileView";
import { HandWritingLiveMobileView } from "@/components/slides/editor/canvas/handWriting/HandWritingLiveMobileView";
import { PhonicsDecodeLiveMobileView } from "@/components/slides/editor/canvas/phonics/decode/PhonicsDecodeLiveMobileView";
import { PhonicsEncodeLiveMobileView } from "@/components/slides/editor/canvas/phonics/encode/PhonicsEncodeLiveMobileView";
import { ReadingFluencyLiveMobileView } from "@/components/slides/editor/canvas/reading/fluency/ReadingFluencyLiveMobileView";
import { WordPronunciationLiveMobileView } from "@/components/slides/editor/canvas/word/pronunciation/WordPronunciationLiveMobileView";
import { WordVocabularyLiveMobileView } from "@/components/slides/editor/canvas/word/vocabulary/WordVocabularyLiveMobileView";
import { useAppSelector } from "@/store/hooks";
import type { SlideTemplate } from "@ai-teach/types";
import { resolveSlideTemplate } from "@ai-teach/types";
import type { JSX } from "react";

// Exhaustive by construction: a new SlideTemplate value fails to compile until it has a preview.
// `isStaticPreview` marks a render that will never play media (the template picker thumbnail);
// only the media-driven views need it.
const LIVE_VIEW_BY_TEMPLATE: Record<SlideTemplate, (isStaticPreview: boolean) => JSX.Element> = {
  vocabulary: () => <WordPronunciationLiveMobileView />,
  listenRepeat: () => <WordVocabularyLiveMobileView />,
  freeformCanvas: () => <FreeFormCanvasLiveMobileView />,
  wordCanvas: () => <FreeFormCanvasLiveMobileView />,
  conversation: () => <GrammarFormLiveMobileView />,
  videoQuestion: (isStaticPreview) => (
    <GrammarResponseLiveMobileView isStaticPreview={isStaticPreview} />
  ),
  audioRevealPrompt: () => <GrammarSentenceLiveMobileView />,
  passageReading: () => <ReadingFluencyLiveMobileView />,
  soundToSpelling: () => <PhonicsEncodeLiveMobileView />,
  spellingToSound: () => <PhonicsDecodeLiveMobileView />,
  handWriting: () => <HandWritingLiveMobileView />,
};

export function useGetLiveMobileView({ isStaticPreview = false } = {}) {
  const { slide } = useAppSelector((state) => state.slideEditor.present);
  const template = resolveSlideTemplate(slide);

  if (!template) return <CanvasSkeleton label="Not Found" />;
  return LIVE_VIEW_BY_TEMPLATE[template](isStaticPreview);
}
